module.exports = __webpack_public_path__ + "static/media/michi.7ac57d30.webp";